<app-pan-action-bar>
  <ol class="inline-flex items-center space-x-1 md:space-x-2">
    <li>
      <app-pan-button panRole [roles]="['admin']" color="info" (click)="editBranch.show()">Edit External ID</app-pan-button>
    </li>

    <li>
      @let errors = fixableErrors();

      <app-pan-modal #errorsModal [topLevel]="false" [shouldBodyScroll]="false" size="sm">
        <div header>Location Errors</div>
        <div body>
          <div class="max-h-[60vh] overflow-auto">
            @for (err of errors; track $index) {
              <div class="my-2">
                {{ $index + 1 }}. <span class="font-bold">{{ err.subject }}</span> - {{ err.error }}
              </div>
            }
          </div>
        </div>

        <div footer class="flex gap-2">
          <app-pan-button panModalClose>Close</app-pan-button>
        </div>
      </app-pan-modal>

      @if (errors.length > 0) {
        <app-pan-button panRole [roles]="['admin']" color="danger" icon="error" (click)="errorsModal.show()">Errors</app-pan-button>
      }
    </li>

    @if (branchData()?.external_id; as extId) {
      <li>
        <app-pan-chip [size]="'lg'">External ID: {{ extId }}</app-pan-chip>
      </li>
    }
  </ol>
</app-pan-action-bar>

@if (isLoading()) {
  <app-pan-blank-slate>
    <app-pan-spinner size="lg"></app-pan-spinner>
  </app-pan-blank-slate>
} @else {
  <app-installer-dashboard-table-providers
    [branchId]="branchId()"
    [currentCameraProviders]="cameraProviders()"
    [allCameraProviders]="allCameraProviders()"
  ></app-installer-dashboard-table-providers>

  <app-installer-dashboard-table-kiosks
    [branchId]="branchId()"
    [allBranchAliases]="allBranchAliases()"
    [allKioskProviders]="allKioskProviders()"
  ></app-installer-dashboard-table-kiosks>

  <app-installer-dashboard-table-locations
    [branchId]="branchId()"
    [branchCamerasByLocationId]="branchCamerasByLocationId()"
    [branchLocations]="branchLocations()"
  ></app-installer-dashboard-table-locations>

  <app-installer-dashboard-table-shoppersense
    [branchId]="branchId()"
    [shoppersenses]="allShoppersenses()"
  ></app-installer-dashboard-table-shoppersense>

  <app-installer-dashboard-table-panobridge
    [branchId]="branchId()"
    [panobridges]="allPanobridges()"
  ></app-installer-dashboard-table-panobridge>
}

<app-pan-modal #editBranch [topLevel]="false" [shouldBodyScroll]="false" size="sm">
  <div header>Edit External ID</div>
  <div body>
    <app-pan-form-control>
      <app-pan-floating-label>Branch External ID</app-pan-floating-label>
      <input panInput [(ngModel)]="editBranchExternalId" placeholder="Branch External ID..." />
    </app-pan-form-control>
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Cancel</app-pan-button>
    <app-pan-button panModalClose color="primary" (click)="saveBranchData()">Save</app-pan-button>
  </div>
</app-pan-modal>

<app-pan-modal #setupDevice [topLevel]="false" [shouldBodyScroll]="false" size="sm">
  <div header>Device Setup</div>
  <div body>What kind of device are you setting up?</div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Cancel</app-pan-button>
    <app-pan-button panModalClose color="primary" (click)="tryRegisterPanobridge()">PanoBridge</app-pan-button>
    <app-pan-button panModalClose color="primary" (click)="tryRegisterShoppersense()">ShopperSense</app-pan-button>
  </div>
</app-pan-modal>
